import { global } from '../global';
import { paths, pathnames } from '../../paths';

export const development = {
  global,
  path: paths.development,
  pathname: pathnames[paths.development],
  content: {
    sections: [
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          },
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          },
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          },
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
        ]
      },
    ]
  }
};
